import { FlightState, TypeFlight } from "@/lib/redux/features/flight/type";
import { isComboFare } from "@/utils/flight/isComboFare";

export const byFlightInputIndex = (state: FlightState, flight: TypeFlight) => {
  const flightInput = state.inputFlights[state.selectedFligthInputIndex]
  const firstSegment = flight.segments[0]
  const lastSegment = flight.segments[flight.segments.length - 1]

  const fare = state.flightsResult.fares[flight.fareDataId]
  const legCount = fare ? (state.flightsResult.layout.mappingFareFlights[fare.index]?.length ?? 1) : 1

  return flightInput.fromAirport?.code === firstSegment.startPoint &&
    flightInput.toAirport?.code === lastSegment.endPoint &&
    flightInput.isReturn ? !isComboFare(fare?.system, legCount) : true
}